import { render, staticRenderFns } from "./ProjectAttachmentsSection.vue?vue&type=template&id=00ebcc91&scoped=true&"
import script from "./ProjectAttachmentsSection.vue?vue&type=script&lang=js&"
export * from "./ProjectAttachmentsSection.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAttachmentsSection.vue?vue&type=style&index=0&id=00ebcc91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ebcc91",
  null
  
)

export default component.exports